/**
 * 全局配置文件
 */
export default {
  title: "fang",
  logo: "F",
  key: 'fang',//配置主键,目前用于存储
  indexTitle: 'Admin',
  clientId: 'fang', // 客户端id
  clientSecret: 'fang_secret', // 客户端密钥
  tenantMode: true, // 是否开启租户模式
  tenantId: "000000", // 管理组租户编号
  captchaMode: false, // 是否开启验证码模式
  lockPage: '/lock',
  tokenTime: 3000,
  tokenHeader: 'fang-Auth',
  //http的status默认放行列表
  statusWhiteList: [],
  //配置首页不可关闭
  isFirstPage: false,
  fistPage: {
    label: "登录",
    value: "/login",
    params: {},
    query: {},
    meta: {
      i18n: 'dashboard'
    },
    group: [],
    close: false
  },
  //配置菜单的属性
  menu: {
    iconDefault: 'iconfont icon-caidan',
    props: {
      label: 'name',
      path: 'path',
      icon: 'source',
      children: 'children'
    }
  },
}



// WEBPACK FOOTER //
// ./src/config/website.js